import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { lang, queryKeys, requestCCApi } from 'src/utils';

export const useDeleteProductCategory = () => {
  return useMutation({
    mutationFn: deleteProductCategory,
    onSuccess: (data, payload) => {
      queryClient.removeQueries(queryKeys.productCategories.details(payload));
      queryClient.invalidateQueries(
        queryKeys.productCategories.invalidateAll(),
      );
    },
  });
};

const deleteProductCategory = async (productCategoryId: number) => {
  const response = await requestCCApi(
    {
      url: `/productCategories/${productCategoryId}`,
      method: 'DELETE',
    },
    true,
    lang.failedToDeleteCategoryCustomErrorMessage,
  );

  return response;
};
